import { parseAbi, parseAbiItem } from 'viem';

export const factoryAbi = parseAbi([
  'function marketCount() view returns (uint256)',
  'function markets(uint256) view returns (address)',
  'function reputationController() view returns (address)',
  'function feeConfig() view returns (address,uint16,uint16)',
  'function createMarket(string,uint64,uint256,string,string,string,string) returns (address)',
  'function createMarket(address,string,uint64,uint256,string,string,string,string) returns (address)',
]);

export const factoryAbiEthers = [
  'function marketCount() view returns (uint256)',
  'function markets(uint256) view returns (address)',
  'function reputationController() view returns (address)',
  'function feeConfig() view returns (address,uint16,uint16)',
  'function createMarket(string,uint64,uint256,string,string,string,string) returns (address)',
  'function createMarket(address,string,uint64,uint256,string,string,string,string) returns (address)',
];

export const lookerAbi = parseAbi([
  'function getMarketAddresses(address,uint256,uint256) view returns (address[])',
  'function getMarketSnapshots(address,uint256,uint256) view returns ((address market,bytes32 marketId,address collateral,address creator,uint64 resolveAfter,bool initialized,bool resolved,uint256 yesReserve,uint256 noReserve,uint256 impliedYesBps,uint256 buyCollateralVolume,uint256 sellCollateralVolume,uint256 totalCollateralVolume,uint256 feesCollected,uint64 totalTrades,uint64 mostRecentTradeAt,uint8 adapterPhase,uint8 adapterOutcome,uint8 marketFinalOutcome)[])',
]);

export const registryAbi = [
  {
    type: 'function',
    name: 'marketCount',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ name: '', type: 'uint256' }],
  },
  {
    type: 'function',
    name: 'getMarketSlice',
    stateMutability: 'view',
    inputs: [
      { name: 'offset', type: 'uint256' },
      { name: 'limit', type: 'uint256' },
    ],
    outputs: [
      {
        name: 'markets',
        type: 'tuple[]',
        components: [
          { name: 'market', type: 'address' },
          { name: 'marketId', type: 'bytes32' },
          { name: 'question', type: 'string' },
          { name: 'resolveAfter', type: 'uint64' },
          { name: 'initialized', type: 'bool' },
          { name: 'resolved', type: 'bool' },
          { name: 'tradingPaused', type: 'bool' },
          { name: 'bucket', type: 'uint8' },
          { name: 'yesToken', type: 'address' },
          { name: 'noToken', type: 'address' },
          { name: 'yesReserve', type: 'uint256' },
          { name: 'noReserve', type: 'uint256' },
          { name: 'finalOutcome', type: 'uint8' },
        ],
      },
    ],
  },
  {
    type: 'function',
    name: 'getWalletSlice',
    stateMutability: 'view',
    inputs: [
      { name: 'account', type: 'address' },
      { name: 'offset', type: 'uint256' },
      { name: 'limit', type: 'uint256' },
    ],
    outputs: [
      {
        name: 'markets',
        type: 'tuple[]',
        components: [
          { name: 'market', type: 'address' },
          { name: 'marketId', type: 'bytes32' },
          { name: 'canClaim', type: 'bool' },
          { name: 'payout', type: 'uint256' },
          { name: 'yesBalance', type: 'uint256' },
          { name: 'noBalance', type: 'uint256' },
          { name: 'userWinningShares', type: 'uint256' },
          { name: 'payoutDenominator', type: 'uint256' },
          { name: 'payoutOutcome', type: 'uint8' },
        ],
      },
    ],
  },
] as const;

export const marketAbi = parseAbi([
  'function marketId() view returns (bytes32)',
  'function question() view returns (string)',
  'function resolveAfter() view returns (uint64)',
  'function resolved() view returns (bool)',
  'function creator() view returns (address)',
  'function liquidityProvider() view returns (address)',
  'function collateral() view returns (address)',
  'function reputationController() view returns (address)',
  'function yesToken() view returns (address)',
  'function noToken() view returns (address)',
  'function yesReserve() view returns (uint256)',
  'function noReserve() view returns (uint256)',
  'function getTradeState() view returns ((bool initialized,bool resolved,bool tradingPaused,bytes32 marketId,address collateral,address creator,uint64 resolveAfter,uint256 yesReserve,uint256 noReserve,uint256 impliedYesBps,address house,uint16 buyFeeBps,uint16 sellFeeBps,uint256 collateralBalance,uint256 buyCollateralVolume,uint256 sellCollateralVolume,uint256 totalCollateralVolume,uint256 feesCollected,uint64 totalTrades,uint64 mostRecentTradeAt))',
  'function quoteTrade(bool,bool,uint256) view returns (uint256,uint256,uint256,uint256,uint256)',
  'function previewBuy(bool,uint256) view returns (uint256)',
  'function previewSell(bool,uint256) view returns (uint256)',
  'function buyYes(uint256) returns (uint256)',
  'function buyNo(uint256) returns (uint256)',
  'function sellYes(uint256) returns (uint256)',
  'function sellNo(uint256) returns (uint256)',
  'function acceptProposedResolution()',
  'function rejectPendingProposal()',
  'function settleMarket()',
  'function claim() returns (uint256)',
  'function quoteClaim(address) view returns (bool,uint256,uint256,uint256,uint256,uint256,uint8)',
  'function getSettlementSnapshot() view returns (bool,uint8,uint8,uint256,uint256,uint256)',
]);

export const marketAbiEthers = [
  'function marketId() view returns (bytes32)',
  'function question() view returns (string)',
  'function resolveAfter() view returns (uint64)',
  'function resolved() view returns (bool)',
  'function creator() view returns (address)',
  'function collateral() view returns (address)',
  'function reputationController() view returns (address)',
  'function yesToken() view returns (address)',
  'function noToken() view returns (address)',
  'function yesReserve() view returns (uint256)',
  'function noReserve() view returns (uint256)',
  'function getTradeState() view returns ((bool initialized,bool resolved,bool tradingPaused,bytes32 marketId,address collateral,address creator,uint64 resolveAfter,uint256 yesReserve,uint256 noReserve,uint256 impliedYesBps,address house,uint16 buyFeeBps,uint16 sellFeeBps,uint256 collateralBalance,uint256 buyCollateralVolume,uint256 sellCollateralVolume,uint256 totalCollateralVolume,uint256 feesCollected,uint64 totalTrades,uint64 mostRecentTradeAt))',
  'function quoteTrade(bool,bool,uint256) view returns (uint256,uint256,uint256,uint256,uint256)',
  'function previewBuy(bool,uint256) view returns (uint256)',
  'function previewSell(bool,uint256) view returns (uint256)',
  'function buyYes(uint256) returns (uint256)',
  'function buyNo(uint256) returns (uint256)',
  'function sellYes(uint256) returns (uint256)',
  'function sellNo(uint256) returns (uint256)',
  'function acceptProposedResolution()',
  'function rejectPendingProposal()',
  'function settleMarket()',
  'function claim() returns (uint256)',
  'function quoteClaim(address) view returns (bool,uint256,uint256,uint256,uint256,uint256,uint8)',
  'function getSettlementSnapshot() view returns (bool,uint8,uint8,uint256,uint256,uint256)',
];

export const adapterAbi = parseAbi([
  'function bondAsset() view returns (address)',
  'function bondToken() view returns (address)',
  'function bondAmount() view returns (uint256)',
  'function reputationController() view returns (address)',
  'function submitOutcome(bytes32,uint8)',
  'function disputeAcceptedProposal(bytes32,uint8)',
  'function creatorResolveDispute(bytes32,uint8)',
  'function acceptProposal(bytes32,uint8)',
  'function acceptProposal(bytes32)',
  'function declineProposal(bytes32)',
  'function declineProposal(bytes32,uint8)',
  'function proposeResolution(bytes32,uint8)',
  'function proposeResolutionPending(bytes32,uint8)',
  'function proposeResolutionWithReason(bytes32,uint8,string)',
  'function proposeResolutionPendingWithReason(bytes32,uint8,string)',
  'function withdrawPendingProposal(bytes32)',
  'function disputeResolution(bytes32)',
  'function disputeResolutionWithReason(bytes32,string)',
  'function finalizeResolution(bytes32) returns (uint8)',
  'function getResolution(bytes32) view returns (bool,uint8)',
  'function getPendingProposal(bytes32) view returns (address,uint8,uint64,bool)',
  'function hasPendingProposal(bytes32) view returns (bool)',
  'function isProposalAccepted(bytes32) view returns (bool)',
  'function getTimeToFinalization(bytes32) view returns (uint64)',
  'function getPendingOutcome(bytes32) view returns (uint8)',
  'function getProposals(bytes32) view returns (address,bool,address,bool,uint8)',
  'function isTradingPaused(bytes32) view returns (bool)',
  'function submitEmergencyRuling(bytes32,uint8)',
  'function escalationOracle() view returns (address)',
  'function disputeWindow() view returns (uint64)',
  'function escalationTimeout() view returns (uint64)',
  'function emergencyDecisionWindow() view returns (uint64)',
  'function CREATOR_DISPUTE_DECISION_WINDOW() view returns (uint64)',
  'function grandJudge() view returns (address)',
  'function assertions(bytes32) view returns (bool,uint64,bytes32,bool,uint8,address,uint8,uint64,bool,address)',
  'function disputeTimingSnapshots(bytes32) view returns (bool,uint64,uint64)',
  'function getDisputeTimeoutStatus(bytes32) view returns (bool,bool,bool,uint64,uint64,uint64,uint64,bool,bool,bool,bool)',
  'function emergencyRulings(bytes32) view returns (bool,uint8,uint64)',
]);

export const adapterAbiEthers = [
  'function bondAsset() view returns (address)',
  'function bondToken() view returns (address)',
  'function bondAmount() view returns (uint256)',
  'function reputationController() view returns (address)',
  'function submitOutcome(bytes32,uint8)',
  'function disputeAcceptedProposal(bytes32,uint8)',
  'function creatorResolveDispute(bytes32,uint8)',
  'function acceptProposal(bytes32,uint8)',
  'function acceptProposal(bytes32)',
  'function declineProposal(bytes32)',
  'function declineProposal(bytes32,uint8)',
  'function proposeResolution(bytes32,uint8)',
  'function proposeResolutionPending(bytes32,uint8)',
  'function proposeResolutionWithReason(bytes32,uint8,string)',
  'function proposeResolutionPendingWithReason(bytes32,uint8,string)',
  'function withdrawPendingProposal(bytes32)',
  'function disputeResolution(bytes32)',
  'function disputeResolutionWithReason(bytes32,string)',
  'function finalizeResolution(bytes32) returns (uint8)',
  'function getResolution(bytes32) view returns (bool,uint8)',
  'function getPendingProposal(bytes32) view returns (address,uint8,uint64,bool)',
  'function hasPendingProposal(bytes32) view returns (bool)',
  'function isProposalAccepted(bytes32) view returns (bool)',
  'function getTimeToFinalization(bytes32) view returns (uint64)',
  'function getPendingOutcome(bytes32) view returns (uint8)',
  'function getProposals(bytes32) view returns (address,bool,address,bool,uint8)',
  'function isTradingPaused(bytes32) view returns (bool)',
  'function submitEmergencyRuling(bytes32,uint8)',
  'function escalationOracle() view returns (address)',
  'function disputeWindow() view returns (uint64)',
  'function escalationTimeout() view returns (uint64)',
  'function emergencyDecisionWindow() view returns (uint64)',
  'function CREATOR_DISPUTE_DECISION_WINDOW() view returns (uint64)',
  'function grandJudge() view returns (address)',
  'function assertions(bytes32) view returns (bool,uint64,bytes32,bool,uint8,address,uint8,uint64,bool,address)',
  'function disputeTimingSnapshots(bytes32) view returns (bool,uint64,uint64)',
  'function getDisputeTimeoutStatus(bytes32) view returns (bool,bool,bool,uint64,uint64,uint64,uint64,bool,bool,bool,bool)',
  'function emergencyRulings(bytes32) view returns (bool,uint8,uint64)',
];

export const erc20Abi = parseAbi([
  'function approve(address,uint256) returns (bool)',
  'function allowance(address,address) view returns (uint256)',
  'function balanceOf(address) view returns (uint256)',
  'function totalSupply() view returns (uint256)',
  'function decimals() view returns (uint8)',
  'function name() view returns (string)',
  'function symbol() view returns (string)',
]);

export const erc20AbiEthers = [
  'function approve(address,uint256) returns (bool)',
  'function allowance(address,address) view returns (uint256)',
  'function balanceOf(address) view returns (uint256)',
  'function totalSupply() view returns (uint256)',
  'function decimals() view returns (uint8)',
  'function name() view returns (string)',
  'function symbol() view returns (string)',
];

export const courtOracleAbi = parseAbi([
  'function stake(uint256)',
  'function unstake(uint256)',
  'function claimStakeRewards() returns (uint256)',
  'function claimAppealRewards() returns (uint256)',
  'function withdrawRewards() returns (uint256)',
  'function commitVote(bytes32,bytes32)',
  'function revealVote(bytes32,uint8,bytes32)',
  'function appealCase(bytes32)',
  'function appealCaseWithReason(bytes32,string)',
  'function getCurrentRound(bytes32) view returns (uint256)',
  'function getRoundData(bytes32,uint256) view returns (bool,bool,uint16,uint64,uint64,uint8)',
  'function getSelectedJurors(bytes32) view returns (address[])',
  'function isSelectedJuror(bytes32,uint256,address) view returns (bool)',
  'function courtCases(bytes32) view returns (bool,bool,bytes32,uint8,uint8,address,address,uint8,uint8,uint64,uint256)',
  'function getVote(bytes32,uint256,address) view returns (bytes32,bool,bool,uint8)',
  'function getAppealBondAmount(uint256) view returns (uint256)',
  'function getJurorStatus(address) view returns (uint256,uint256,uint256,uint256,bool,bool,bool)',
  'function getJurorRewards(address) view returns (uint256,uint256)',
  'function getCaseSummary(bytes32) view returns (bool,bool,bytes32,uint8,uint8,address,address,uint8,uint8,uint64,uint256,uint256)',
  'function getJurorRoundStatus(bytes32,uint256,address) view returns (bool,bool,bool,uint8,bool,uint64,uint64)',
  'function getJurorCaseTiming(bytes32) view returns (bool,bool,uint256,bool,bool,bool,uint64,uint64,uint64)',
  'function getJurorCaseParticipation(bytes32,address) view returns (bool,bool,bool,uint8,bool,bool,bool)',
  'function stakes(address) view returns (uint256)',
  'function stakeRewards(address) view returns (uint256)',
  'function appealRewards(address) view returns (uint256)',
  'function minimumStake() view returns (uint256)',
  'function stakeAsset() view returns (address)',
  'function appealBondAsset() view returns (address)',
]);

export const courtOracleAbiEthers = [
  'function stake(uint256)',
  'function unstake(uint256)',
  'function claimStakeRewards() returns (uint256)',
  'function claimAppealRewards() returns (uint256)',
  'function withdrawRewards() returns (uint256)',
  'function commitVote(bytes32,bytes32)',
  'function revealVote(bytes32,uint8,bytes32)',
  'function appealCase(bytes32)',
  'function appealCaseWithReason(bytes32,string)',
  'function getCurrentRound(bytes32) view returns (uint256)',
  'function getRoundData(bytes32,uint256) view returns (bool,bool,uint16,uint64,uint64,uint8)',
  'function getSelectedJurors(bytes32) view returns (address[])',
  'function isSelectedJuror(bytes32,uint256,address) view returns (bool)',
  'function courtCases(bytes32) view returns (bool,bool,bytes32,uint8,uint8,address,address,uint8,uint8,uint64,uint256)',
  'function getVote(bytes32,uint256,address) view returns (bytes32,bool,bool,uint8)',
  'function getAppealBondAmount(uint256) view returns (uint256)',
  'function getJurorStatus(address) view returns (uint256,uint256,uint256,uint256,bool,bool,bool)',
  'function getJurorRewards(address) view returns (uint256,uint256)',
  'function getCaseSummary(bytes32) view returns (bool,bool,bytes32,uint8,uint8,address,address,uint8,uint8,uint64,uint256,uint256)',
  'function getJurorRoundStatus(bytes32,uint256,address) view returns (bool,bool,bool,uint8,bool,uint64,uint64)',
  'function getJurorCaseTiming(bytes32) view returns (bool,bool,uint256,bool,bool,bool,uint64,uint64,uint64)',
  'function getJurorCaseParticipation(bytes32,address) view returns (bool,bool,bool,uint8,bool,bool,bool)',
  'function stakes(address) view returns (uint256)',
  'function stakeRewards(address) view returns (uint256)',
  'function appealRewards(address) view returns (uint256)',
  'function minimumStake() view returns (uint256)',
  'function stakeAsset() view returns (address)',
  'function appealBondAsset() view returns (address)',
];

export const reputationAbi = parseAbi([
  'function scores(address) view returns (uint256)',
  'function proposerCooldownUntil(address) view returns (uint64)',
  'function disputerCooldownUntil(address) view returns (uint64)',
  'function proposerIncorrectStreak(address) view returns (uint8)',
  'function disputerIncorrectStreak(address) view returns (uint8)',
  'function getRequiredBond(address,uint256,bool) view returns (uint256)',
]);

export const gvrAbi = parseAbi([
  'function balanceOf(address) view returns (uint256)',
]);

export const gvrAbiEthers = [
  'function balanceOf(address) view returns (uint256)',
];

export const events = {
  transfer: parseAbiItem('event Transfer(address indexed from, address indexed to, uint256 value)'),
  bought: parseAbiItem('event Bought(address indexed user, bool indexed isYes, uint256 collateralIn, uint256 sharesOut)'),
  sold: parseAbiItem('event Sold(address indexed user, bool indexed isYes, uint256 sharesIn, uint256 collateralOut)'),
  claimed: parseAbiItem('event Claimed(address indexed user, uint256 payout)'),
  marketCreated: parseAbiItem('event MarketCreated(uint256 indexed marketIndex, address indexed market, string question, uint64 resolveAfter)'),
  proposed: parseAbiItem('event ResolutionProposed(bytes32 indexed marketId, address indexed proposer, uint8 outcome)'),
  proposedReason: parseAbiItem('event ResolutionProposedReason(bytes32 indexed marketId, address indexed proposer, uint8 outcome, string reason)'),
  disputed: parseAbiItem('event ResolutionDisputed(bytes32 indexed marketId, address indexed disputer)'),
  proposalDisputed: parseAbiItem('event ProposalDisputed(bytes32 indexed marketId, address indexed disputer, uint8 disputedOutcome, uint64 decisionDeadline)'),
  disputedReason: parseAbiItem('event ResolutionDisputedReason(bytes32 indexed marketId, address indexed disputer, string reason)'),
  disputeResolvedByCreator: parseAbiItem('event DisputeResolvedByCreator(bytes32 indexed marketId, address indexed creator, uint8 finalOutcome)'),
  appealReason: parseAbiItem('event AppealReason(bytes32 indexed marketId, uint256 indexed roundIndex, address indexed appellant, string reason)'),
  finalized: parseAbiItem('event ResolutionFinalized(bytes32 indexed marketId, uint8 outcome)'),
};
